import RoutesMap from '../../../route_control/RouteControl'
import { Button, Form } from 'react-bootstrap'
import Password from '../../input_fields/Password'
import { useFormik } from 'formik'
import ButtonLoader from '../../loader/ButtonLoader'
import { ChangePasswordSchema } from './ValidationSchema'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { changePassword } from '../../../redux/slices/assets/ChangePassword'
import { useNavigate } from 'react-router-dom'
import { toggleChangePasswordModal } from '../../../redux/slices/globalSlice'
import { useTranslation } from 'react-i18next'

export const ChangePasswordFormImport = {
    RoutesMap,
    Button,
    Form,
    Password,
    useFormik,
    ButtonLoader,
    ChangePasswordSchema,
    useDispatch,
    toast,
    changePassword,
    useNavigate,
    toggleChangePasswordModal,
    useTranslation
}